import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useCopyText } from '../../../../../../generic-hooks'
import { urlResolverGetProductShareUrl } from '../../../../../../url-handling'
import { useProductPageContext } from '../../../../productPageContext'

const ProductBuyBoxSocialPopupModalCopyLink: FC = () => {
  const { product } = useProductPageContext()

  /**
   * TODO: Pass device type instead of hardcoded, to return the right url to be copied
   */
  const urlToBeCopied = urlResolverGetProductShareUrl(product, 'desktop')

  const { copied, copyText } = useCopyText(urlToBeCopied)

  return (
    <>
      <div className="my-5 truncate rounded-full border border-dark-primary-min bg-light-primary-low px-6 py-4 text-dark-primary-strong">
        {copied ? (
          <div className="text-dark-success-strong">
            <FormattedMessage id="socialModal.label.linkCopied" />
          </div>
        ) : (
          urlToBeCopied
        )}
      </div>
      <button
        className="font-medium text-dark-brand hover:underline"
        onClick={(): void => {
          void copyText()
        }}
        type="button"
      >
        <FormattedMessage id="socialModal.button.copyLink" />
      </button>
    </>
  )
}

export { ProductBuyBoxSocialPopupModalCopyLink }
